<template>
  <div class="modal fade show my-2" aria-labelledby="selectChequeModalTitle" style="display: block; background: #1c1d1c33">
    <div class="modal-dialog modal-dialog-centered" ref="modalRef">
      <div class="modal-content">
        <div class="row">
          <div class="col-12">
            <div class="d-flex justify-content-between px-1 my-1 align-item-center">
              <h1 class="mb-0">Select Cheque</h1>
              <button
                @click="onClickClose"
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
          </div>
        </div>

        <hr class="mt-0 mb-0">

        <div class="pb-2">
          <div class="row mx-2 mt-1">
            <div class="col-12">
              <label class="form-label">Bank Account <span class="required">*</span></label>
              <v-select
                placeholder="Select Bank Account"
                v-model="selectedAccountHeadId"
                :options="cashAndBank"
                label="name"
                :reduce="item => item.id"
              />
            </div>

            <div class="col-12 mt-1">
              <label class="form-label">Cheque <span class="required">*</span></label>
              <AsyncSelect
                placeholder="Select Cheque"
                v-model="selectedCheque"
                :api-service="fetchChequeRegisterData"
                :additional-query="{ account_head_id: selectedAccountHeadId, status: 'active' }"
                :disabled="!selectedAccountHeadId"
                label="cheque_number"
                :format-label="option => option.cheque_number"
                :reduce="item => item"
              />
            </div>

            <div class="col-12 text-center mb-2 mt-2">
              <button
                :disabled="!selectedCheque || !selectedAccountHeadId"
                @click="submit"
                type="button"
                class="btn btn-primary waves-effect waves-float waves-light"
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, watch, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import AsyncSelect from '@/components/molecule/input-field/AsyncSelect.vue'
import handleAccounting from '@/services/modules/accounting'
import handlePayment from '@/services/modules/payment'

export default {
  name: 'SelectChequeModal',
  components: { AsyncSelect },
  props: {
    preselectedChequeId: { type: Number, default: null }
  },
  emits: ['close', 'selected'],
  setup(props, { emit }) {
    const selectedAccountHeadId = ref(null)
    const selectedCheque = ref(null)
    const cashAndBank = ref([])

    const $route = useRoute()
    const { fetchChequeRegisterData, fetchSingleChequeRegister } = handleAccounting()
    const { fetchCashAndBank } = handlePayment()

    watch(selectedAccountHeadId, (newVal, oldVal) => {
      if (oldVal !== null) {
        selectedCheque.value = null
      }
    })

    onMounted(async () => {
      const companyId = $route.params.companyId
      const res = await fetchCashAndBank(companyId).catch(() => null)
      if (res && res.data) cashAndBank.value = res.data

      if (!props.preselectedChequeId) return
      const query = `?company_id=${companyId}`
      const chequeRes = await fetchSingleChequeRegister(props.preselectedChequeId, query).catch(() => null)
      if (!chequeRes || !chequeRes.status) return
      selectedAccountHeadId.value = chequeRes.data.account_head_id
      selectedCheque.value = chequeRes.data
    })

    const submit = () => {
      if (!selectedCheque.value || !selectedAccountHeadId.value) return
      emit('selected', {
        cheque: selectedCheque.value,
        accountHeadId: selectedAccountHeadId.value
      })
      emit('close')
    }

    const onClickClose = () => {
      emit('close')
    }

    return {
      selectedAccountHeadId,
      selectedCheque,
      cashAndBank,
      fetchChequeRegisterData,
      submit,
      onClickClose
    }
  }
}
</script>
